import { SearchForm } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { AllSchedulingMethods, Periods } from 'constants/meetings';
import { useFilters } from 'hooks/meetings/filters';
const containerCss = "c1cmzhal";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Search = () => {
  const {
    getFilterParams,
    applyFilterParams,
    isValidApplyParams
  } = useFilters();
  const filterParams = getFilterParams({
    scheduling_methods: AllSchedulingMethods,
    period: Periods.PAST
  });
  const dispatch = useDispatch();
  const handleSearch = value => {
    const queryParams = {
      ...filterParams,
      query: value
    };
    if (isValidApplyParams(queryParams)) {
      dispatch(applyFilterParams(queryParams));
    }
  };
  return <Container>
      <SearchForm initialValue={filterParams.query} placeholder={I18n.t('publisher.recaps.search')} onSearch={handleSearch} isFullSized />
    </Container>;
};

require("./search.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search.js");